export default "__VITE_ASSET__Dp4BfJXY__"